import React, {  Component,useState,useEffect,createContext,useContext } from "react";
import "./styles.css";
import "./App.css";
import Get from "./Get";
import Test from "./Test";
import SetParameter from "./SetParameter";
import CheckParameter from "./CheckParameter";
import ExecuteCommand from "./ExecuteCommand";
import HTTPRequest from "./HTTPRequest";
//import CreateProcess from "./CreateProcess";  // CreateProcess component for Liveagent WebSocket
import ChatBot from 'react-simple-chatbot';
import axios from "axios";
import { ThemeProvider } from 'styled-components';
import chatbot from './images/bot.PNG';
import userbot from './images/userbot.png';
import chaticon from './images/chaticon.png';
import { token, queryParams, queryParamsmenu, domainurl } from './constants/global';

const numValidate = (value) => {
  if (isNaN(value)) {
    return 'value should be a number';
  }
  return true;
}


const emailValidate = (value) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
  {
    return true;
  }
    // alert("You have entered an invalid email address!")
    return 'Invalid Email Address';
}

const mobileValidate = (value) => {
  var phoneno = /^\d{10}$/;
  if(value.match(phoneno))
        {
      return true;
        }
      else
        {
        // alert("message");
        return 'Please enter 10 digit mobile number';
        }
}

const crnnovalidate = (value) => {
  var crnno = /^\d{8}$/;
  if(value.match(crnno))
        {
      return true;
        }
      else
        {
        // alert("message");
        return 'Please enter 8 digit CRN Number';
        }
}

const alphaValidate = (value) => {
  var letters = /^[A-Za-z]+$/;
  if(value.match(letters))
    {
     return true;
    }
  else
    {
    return 'Please enter alphabets  Only';
    }
}

const intfloatValidate = (value) => {
	var data = /^(?=.*[1-9])\d*(?:\.\d+)?$/;
	if(value.match(data))
    {
     return true;
    }
  else
    {
    return 'Enter decimal or integer numbers';
    }
}



function getType(p) {	
  if (Array.isArray(p)) return 'array';	
  else if (typeof p == 'string') return 'string';	
  else if (p != null && typeof p == 'object') return 'object';	
  else return 'other';	
}

export const NotificationbodyContext = createContext();

function App() {
  const [notifications, setNotifications] = useState("Notopic");
  const config = {
   
    
    
    headerTitle:(
      <div className="HeaderText">
        
        <img style={{ width: 39, height: 39 }} src={chatbot} />
        <span>Ask ..</span>
        <sapn className="blink active"></sapn>
      </div> ) ,
    
   
    
    floatingIcon:(
      <img style={{ width: 49, height: 69,"position": "absolute","bottom": "13px" }} src={chaticon} />
    )
};

  const theme = {
    
    headerBgColor: '#f8cc07',
    fontFamily: 'Poppins',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#f4eca9',
    botFontColor: 'blue', 
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
  };
  // handleClear = () => {
  //   console.log("handel clear");
  //   this.setState({ clear: true }, () => {
  //     this.setState({ clear: false });
  //   });
  // }

  const [ckey,setKey]=useState("1234");
  function makecomp(ids,names,triggers){
    let cp=<names/>
    let cs={
   
      id: ids,
      component:cp,
      trigger:triggers
     
  };
  return cs;
  }
  
  const [stepdata,setStepdata]=useState([
    {
      id: '1',
      message: 'What is your name?',
      end: true,
    }
  ])

  const imgparameter = {
    Url: "https://convergenow.ai/platform/chatbot/imageupload",
    Username: null,
    Password: null,
    Post: true,
    StoreResponse: false,
    ParameterName: "HTTPRequest_Result",
    ParameterPurpose: "Temporary",
    ContentType: "Json",
    AddProcessInstanceParameters: true,
    Headers: null,
    Parameters: `{
      "crnnumber": "%%",
      "imageupload": "%%",
      "mobile":"%%",
      "email":"%%",
      "meterreading":"%%"
      
      
    }`
  };

  const imgparams = {
    Url: "https://convergenow.ai/platform/chatbot/imageupload",
    Username: null,
    Password: null,
    Post: true,
    StoreResponse: false,
    ParameterName: "HTTPRequest_Result",
    ParameterPurpose: "Temporary",
    ContentType: "Json",
    AddProcessInstanceParameters: true,
    Headers: null,
    Parameters: `{
      "meternumber": "%%",
      "image": "%%",
      "mobile":"%%",
      "email":"%%",
      "meterreading1":"%%"		
      
    }`
  };
  
  useEffect(()=>{
  
        axios.post(domainurl + '/getdata',{	
        "client_id":queryParams
    })
    
    
       .then(function (response) {	
        var rp=response.data;	
        console.log(rp);	
        var st=[];	
        for(let i = 0; i < rp.length; i++) {	
          let obj = rp[i];	
          	
          let ct=<Test />;	
          let cs={};	
          cs.id=obj.id;	
          if(obj.hasOwnProperty('component')){	
            if(obj.component=='ExecuteCommand' && obj.id!="complaintcategory"){	
              if(getType(obj.parameter)=='object'){	
                cs.component=<ExecuteCommand datas={obj.parameter.CommandName}/>	
                cs.asMessage=true;	
              }else{	
                cs.component=<ExecuteCommand datas={obj.parameter}/>	
                cs.asMessage=true;	
              }	
              	
            }else if(obj.component=='SetParameter'){	
              	
              cs.component=<SetParameter datas={(obj.parameter)}/>	
              cs.asMessage=true;	
            }else if(obj.component=='CheckParameter'){	
              	
              cs.component=<CheckParameter datas={(obj.parameter)}/>	
              cs.asMessage=true;	
            }else if(obj.component=='HTTPRequest'){	
              cs.component=<HTTPRequest datas={(obj.parameter)}/>	
              cs.asMessage=true;
            }  	
            else if(obj.id=='complaintcategory'){
              cs.options=[
                {
                    "value": "After Sales/Maintenance",
                    "label": "After Sales/Maintenance",
                    "trigger": "complaint"
                },
                {
                    "value": "Registration and Marketing",
                    "label": "Registration and Marketing",
                    "trigger": "complaint"
                },
                {
                    "value": "Metering",
                    "label": "Metering",
                    "trigger": "complaint"
                },
                {
                    "value": "Billing",
                    "label": "Billing",
                    "trigger": "complaint"
                },
                {
                    "value": "Project work",
                    "label": "Project work",
                    "trigger": "complaint"
                }
            ];

            }
           	
          }	
          if(obj.hasOwnProperty('options')){
            console.log("options");
            console.log(obj.options);	

            cs.options=obj.options;
            
            	
          }	
          if(obj.hasOwnProperty('end')){	
            cs.end=obj.end;	
          }
          if(obj.hasOwnProperty('end')){	
            cs.end=true;	
          }	
          if(obj.hasOwnProperty('trigger')){	
            if(obj.hasOwnProperty('component') && obj.component=='ExecuteCommand' && getType(obj.parameter)=='object' &&obj.parameter.ProcessId=="next" ){	
              cs.trigger=obj.trigger;	
            }else if(obj.hasOwnProperty('component') && obj.component=='SetParameter' && getType(obj.parameter)=='object' &&obj.parameter.ParameterName=="Url" ){	
              cs.trigger=obj.trigger;	
            }else if(obj.hasOwnProperty('component') && obj.component=='ExecuteCommand' && getType(obj.parameter)=='object' && obj.parameter.ProcessId!="" ){
              cs.trigger=obj.id.toString()+"input";
              console.log(cs.validate)
              console.log(cs.trigger);
            }
            // else if(obj.hasOwnProperty('component') && obj.component=='ExecuteCommand' && getType(obj.parameter)=='object' && obj.parameter.ProcessId.toString()){
            //   cs.trigger=obj.id.toString();
              
            // }
            else{	
              cs.trigger=obj.id.toString()+"input";	
            }	
            //console.log(getType(obj.parameter));	
            	
             	
          }
          st.push(cs);	
          if(obj.id=="crnnometerchoose"){
            console.log("---------1");
            st.push(
            {
              id: 'imagecomp',
              message:"Upload Meter Reading Image",
              trigger: 'imageupload',
            },
            {
              id: "imageupload",
              user:true,
              input_type:true,
              trigger: 'imageapi',
            },
            {
              id:"imageapi",
              component: <HTTPRequest datas={imgparameter}/>,
              trigger: "inputconcern"
            },
            {
              id: 'imagecmp',
              message:"Upload Meter Reading Image",
              trigger: 'image',
            },
            {
              id: "image",
              user:true,
              input_type:true,
              trigger: 'imageapi1',
            },{
              id:"imageapi1",
              component: <HTTPRequest datas={imgparams}/>,
              trigger: "inputconcern" 
            }
           
                      ); 

          }
          
          if(i!=0 || i<rp.length-1){	
            if(obj.hasOwnProperty('options') || obj.hasOwnProperty('end')){	
             // st.pop();	
            }else{	
              if(obj.hasOwnProperty('component') && obj.component=='ExecuteCommand' && getType(obj.parameter)=='object' && obj.parameter.ProcessId!="" && obj.parameter.ProcessId!="next" ){
                

                st.push({	
                  id:obj.id.toString()+"input",	
                  user:true,	
                  validator:eval(obj.parameter.ProcessId),
                  trigger:obj.trigger	
                });	
              }	else{
                st.push({	
                  id:obj.id.toString()+"input",	
                  user:true,	
                  trigger:obj.trigger	
                });	
              }
              
            }	
            	
          }	
        }	
         console.log("sss");	
         console.log(st);	
         //	
        setStepdata(st);	
        setKey("4567");	
       	
      })	
  	
  },[]);	
    
  
  
    return (
    
    <ThemeProvider theme={theme}>
      <NotificationbodyContext.Provider value={{notifications, setNotifications}}> 
      <ChatBot  
      // recognitionEnable={true}
      botAvatar={chatbot}
      userAvatar={userbot}
      key={ckey}
      steps={stepdata}
      {...config}
      
      />
      </NotificationbodyContext.Provider>
     </ThemeProvider>
    );
  //}
  
 
  
}


export default App;


